import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {PreviousMeetingsWidgetConfig} from "./previous-meetings-widget.config";
import {PreviousMeetingsWidgetState} from "./models/previous-meetings-widget.state";

export class PreviousMeetingsWidgetStore extends BaseMobxStore {
  static injectables = [PreviousMeetingsWidgetConfig, PreviousMeetingsWidgetState];
}